var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bulk_calendar",
    "data-name": "vuesax/bulk/calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H22V22H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.569,2.117V.688a.688.688,0,0,0-1.375,0V2.063H5.235V.688a.688.688,0,0,0-1.375,0v1.43A3.894,3.894,0,0,0,0,6.013.461.461,0,0,0,.459,6.5h15.51a.455.455,0,0,0,.458-.486A3.894,3.894,0,0,0,12.569,2.117Z",
    transform: "translate(2.786 1.146)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M15.583,0A.919.919,0,0,1,16.5.917V6.563c0,2.75-1.375,4.583-4.583,4.583H4.583C1.375,11.147,0,9.313,0,6.563V.917A.919.919,0,0,1,.917,0Z",
    transform: "translate(2.75 9.02)",
    fill: "#191919",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.875 11.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.917,1.832a.964.964,0,0,1-.651-.266A.964.964,0,0,1,0,.916.964.964,0,0,1,.266.265a.916.916,0,0,1,1-.193.856.856,0,0,1,.3.193.964.964,0,0,1,.266.651.964.964,0,0,1-.266.651A.964.964,0,0,1,.917,1.832Z",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(10.083 11.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.917,1.832a.964.964,0,0,1-.651-.266A.964.964,0,0,1,0,.916.964.964,0,0,1,.266.265a.856.856,0,0,1,.3-.193.916.916,0,0,1,1,.193.964.964,0,0,1,.266.651.964.964,0,0,1-.266.651l-.137.11a.694.694,0,0,1-.165.083.583.583,0,0,1-.165.055A1.242,1.242,0,0,1,.917,1.832Z",
    transform: "translate(0 0)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(13.292 11.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M.917,1.833a.964.964,0,0,1-.651-.266A.964.964,0,0,1,0,.917.964.964,0,0,1,.266.266a.946.946,0,0,1,.3-.193A.876.876,0,0,1,1.1.018a.583.583,0,0,1,.165.055A.694.694,0,0,1,1.43.156l.137.11a.964.964,0,0,1,.266.651.964.964,0,0,1-.266.651l-.137.11a.694.694,0,0,1-.165.083.583.583,0,0,1-.165.055A1.378,1.378,0,0,1,.917,1.833Z",
    transform: "translate(0 0)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group",
    transform: "translate(6.875 15.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M.917,1.833A.912.912,0,0,1,.568,1.76a.946.946,0,0,1-.3-.193A.964.964,0,0,1,0,.917.964.964,0,0,1,.266.266a.946.946,0,0,1,.3-.193A.876.876,0,0,1,1.1.018a.583.583,0,0,1,.165.055A.694.694,0,0,1,1.43.156l.137.11a.964.964,0,0,1,.266.651.964.964,0,0,1-.266.651,1.444,1.444,0,0,1-.137.11.694.694,0,0,1-.165.083.583.583,0,0,1-.165.055A1.242,1.242,0,0,1,.917,1.833Z",
    transform: "translate(0 0)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group",
    transform: "translate(10.083 15.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M.917,1.822a.964.964,0,0,1-.651-.266A.964.964,0,0,1,0,.905.964.964,0,0,1,.266.254a.96.96,0,0,1,1.3,0,.964.964,0,0,1,.266.651.964.964,0,0,1-.266.651A.964.964,0,0,1,.917,1.822Z",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    "data-name": "Group",
    transform: "translate(13.292 15.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M.917,1.822a.964.964,0,0,1-.651-.266A.964.964,0,0,1,0,.905.964.964,0,0,1,.266.254a.96.96,0,0,1,1.3,0,.964.964,0,0,1,.266.651.964.964,0,0,1-.266.651A.964.964,0,0,1,.917,1.822Z",
    fill: "#191919"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.61d56060de8939213ef21b11e92e0ec5.svg";
export { ForwardRef as ReactComponent };